import { Helmet } from 'react-helmet-async';
import Header from './header';
import PurchaseRecords from './purchase-records';
import PurchaseProvider from './provider';

const PurchaseScreen = () => {
  return (
    <PurchaseProvider>
      <Helmet>
        <title> Purchases </title>
      </Helmet>
      <Header />
      <PurchaseRecords />
    </PurchaseProvider>
  );
}

export default PurchaseScreen;
